module.exports = __webpack_public_path__ + "static/img/void.0a3d36f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/void.png
// module id = 5j/7
// module chunks = 1